import React from 'react';

import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import { imgPath } from '../../common/utilities/ImgUrl';
import { Messages } from '../../codegen/Localize';
import { InteractiveModalDialog } from '../styles/StarterStyles';

export interface StartersModalCloseButtonProps {
  handleClick: () => void;
  tooltipText: string;
}

const getCloseButtonContent = (): JSX.Element => {
  return (
    <div className={InteractiveModalDialog.CloseButton}>
      <div style={{display: 'inline-flex'}}>
        <img
          src={imgPath('dialogs_close_active.svg')}
          draggable={false}
          alt={Messages.startersCloseButtonAltText()}
          style={{width: '100%', height: '100%'}}
        />
      </div>
    </div>
  );
};

export class StartersModalCloseButton extends React.PureComponent<StartersModalCloseButtonProps> {

  private getTooltipContent = (): Promise<JSX.Element> => {
    return new Promise(resolve => {
      // Adds a delay to the Tooltip showing. Example taken from the shared-widgets docs
      window.setTimeout(() => { resolve(<span>{this.props.tooltipText}</span>); }, 350);
    });
  }

  render() {
    return (
      <div className={InteractiveModalDialog.CloseButtonContainer}>
        <Tooltip
          position={TooltipPosition.Right}
          testId={'starters-modal-close-tooltip'}
          getContent={this.getTooltipContent}
        >
          <ButtonWidget
            buttonType={ButtonType.IconOutline}
            handleClick={this.props.handleClick}
            testId={'starters-modal-close'}
            getContent={getCloseButtonContent}
          />
        </Tooltip>
      </div>
    );
  }
}
